import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Text, Heading, Stack, Input } from '@guestyci/arc';
import { StepActions } from '../../layout';

const ManualSetupStep = ({ manualSetupKey, onNext, onPickDifferentMethod, isSubmitting }) => {
  return (
    <Stack spacing={6} justify="between" className="gst-w-full gst-flex-1">
      <Stack spacing={6}>
        <Stack spacing={6}>
          <Heading variant="h2">{t('Set up Google Authenticator')}</Heading>
          <Text size="sm">{t("Can't scan barcode?")}</Text>
          <Text size="sm">
            {t('To set up manually, enter your Guesty Account username and then input the following in the Secret Key Field')}
          </Text>
        </Stack>

        <Input
          value={manualSetupKey || ''}
          readOnly
        />
      </Stack>

      <StepActions
        onPrimaryClick={onNext}
        onSecondaryClick={onPickDifferentMethod}
        isSubmitting={isSubmitting}
      />
    </Stack>
  );
};

export default ManualSetupStep;
